import type { YachtDie } from "@cloudnest/yacht-engine";

function LockIcon() {
  return (
    <svg
      aria-hidden="true"
      className="yacht-lock-icon"
      focusable="false"
      viewBox="0 0 16 16"
    >
      <path d="M5 7V5.6C5 3.65 6.25 2.4 8 2.4s3 1.25 3 3.2V7h.45c.63 0 1.15.52 1.15 1.15v3.9c0 .63-.52 1.15-1.15 1.15h-6.9c-.63 0-1.15-.52-1.15-1.15v-3.9C3.4 7.52 3.92 7 4.55 7H5Zm1.35 0h3.3V5.6c0-1.2-.65-1.9-1.65-1.9s-1.65.7-1.65 1.9V7Z" />
    </svg>
  );
}

export function DieButton({
  die,
  held,
  disabled,
  onToggle,
}: {
  readonly die: YachtDie;
  readonly held: boolean;
  readonly disabled: boolean;
  readonly onToggle: () => void;
}) {
  return (
    <button
      aria-pressed={held}
      className="yacht-die-button"
      data-held={held ? "true" : "false"}
      data-testid="yacht-die"
      disabled={disabled || die === null}
      onClick={onToggle}
      type="button"
    >
      {held && <LockIcon />}
      <span className="yacht-die-face">{die ?? "-"}</span>
    </button>
  );
}
